<template>
    <div class="caseFiji">
      <Helmet>
        <title>Case Lebanon - inte-QT</title>
        <meta name="title" content="Case Lebanon - inte-QT" />
        <meta name="description" :content="cases[1].title" />
        <link rel="canonical" href="https://www.inte-qt.com/cases/lebanon" />
      </Helmet>
  
      <img
        :src="cases[1].img"
        alt="bigbanner-background"
        class="banner-img banner-img__black"
      />
      <h1 class="banner-img__header text-center">{{ cases[1].title }}</h1>
  
      <div class="container-fluid caseFiji">
        <div class="container">
          <div class="caseFiji__aux">
            <p class="caseFiji__title text-center center-header mx-auto">
              {{ cases[1].title }}
            </p>
            <h3 class="my-5">Challenge</h3>
            <p>{{ cases[1].p1 }}</p>
            <p>{{ cases[1].p2 }}</p>
  
            <h3 class="my-5">Goals</h3>
            <ul>
              <li>
                <p>{{ cases[1].p3 }}</p>
              </li>
              <li>
                <p>{{ cases[1].p4 }}</p>
              </li>
            </ul>
  
            <h3 class="my-5">Solution</h3>
            <p>{{ cases[1].p5 }}</p>
  
            <h3 class="my-5">Learnings</h3>
            <p>{{ cases[1].p6 }}</p>
            <p>{{ cases[1].p7 }}</p>
            <p>{{ cases[1].p8 }}</p>
            <p>{{ cases[1].p9 }}</p>
            <p>{{ cases[1].p10 }}</p>
          </div>
  
          <div class="cases__box">
            <div class="row">
              <div class="col-lg-6 col-md-12">
                <h2 class="cases__companyName mx-3">{{ cases[0].title }}</h2>
                <p class="cases__text m-3" align="justify">
                  {{ cases[0].p3 }}
                </p>
                <div class="text-end mx-3">
                  <DinamicLink :url="'/cases/fiji'" name="Read more" />
                </div>
              </div>
              <div class="col-lg-6 col-md-12">
                <img :src="cases[0].img" alt="1" class="cases__img" />
              </div>
            </div>
          </div>
        </div>
      </div>
  
      <GetInTouch />
    </div>
  </template>
  
  <script>
  import DinamicLink from '@/components/DinamicLink';
  import GetInTouch from '@/components/GetInTouch';
  import { Helmet } from 'vue-helmet'; 
  
  export default {
    name: 'CasesLebanon',
    components: {
      DinamicLink,
      GetInTouch,
      Helmet
    },
    data() {
      return {
        cases: require('@/data/casesInfo.json')
      };
    },
    mounted() {
      window.scrollTo(0, 0);
    }
  };
  </script>
  
  <style scoped>
  .caseFiji {
    color: black;
    line-height: 1.5;
    margin-top: 5rem;
  }
  
  .caseFiji__title {
    margin: 5rem;
  }
  
  .caseFiji__aux {
    padding: 5rem 12rem;
  }
  
  .caseFiji__space {
    margin-top: 6rem;
  }
  
  @media (max-width: 768px) {
    .caseFiji {
      line-height: 1.2;
      margin-top: 0rem;
    }
  
    .caseFiji__title {
      margin: 1rem;
    }
  
    .caseFiji__aux {
      padding: 1rem;
    }
  }
  .caseFiji {
    color: black;
    line-height: 1.5;
    margin-top: 5rem;
  }
  
  .caseFiji__title {
    text-align: center;
    margin: 0 auto;
    font-size: 3rem;
  }
  
  .caseFiji__aux {
    margin: 0 1rem;
  }
  
  .caseFiji__header {
    font-size: 2.5rem;
    text-align: center;
  }
  
  .banner-img {
    width: 100%;
  }
  
  .banner-img__black {
    background-color: black;
  }
  
  .banner-img__header {
    position: absolute;
    width: 40vw;
    top: 45vh;
    left: 55vw;
    line-height: 1.5;
    font-size: 4rem;
    font-weight: bold;
    color: white;
  }
  
  .banner-img__header.text-center {
    text-align: center;
  }
  
  ul {
    list-style-type: disc;
    padding-left: 2rem;
  }
  
  ul li {
    margin-bottom: 0.5rem;
  }
  
  .cases__box {
    margin-top: 3rem;
  }
  
  .cases__companyName {
    font-size: 2rem;
    font-weight: bold;
  }
  
  .cases__text {
    text-align: justify;
    font-size: 1.2rem;
  }
  
  .cases__img {
    max-width: 100%;
  }
  
  .center-header {
    font-size: 2rem;
    font-weight: bold;
    margin-top: 3rem;
  }
  
  .my-5 {
    margin-top: 3rem;
    margin-bottom: 3rem;
  }
  
  .text-end {
    text-align: right;
  }
  
  .mx-3 {
    margin-left: 1rem;
    margin-right: 1rem;
  }
  
  @media screen and (max-width: 768px) {
    .banner-img__header {
      font-size: 2.5rem;
      top: 30vh;
      left: 55vw;
    }
    .caseFiji__title {
      font-size: 2rem;
    }
  
    .cases__companyName {
      font-size: 1.5rem;
    }
  }
  </style>
  